import { Box, Typography } from '@mui/material'
import ReachAfrikaDatePicker from 'components/DateRangePicker'
import dayjs from 'dayjs'
// import DatePickers from 'components/DatePickers'
import React, { useContext, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { GrFormClose } from 'react-icons/gr'
import useSWR from 'swr'
import ReachBarChart from './BarChart'
import { ReviewContext } from './reviewContext'

function ReviewChart({ t, view, currentBranch }) {
    const [params, setParams] = useState({ start: '', end: '' })
    const { showReviewChart, setShowReviewChart } = useContext(ReviewContext)
    const { data: graphData } = useSWR(`merchants/ratings/branch/${currentBranch.id}/summary?${params.start ? 'start=' + params.start : ''}${params.end ? '&end=' + params.end : ''}`)
    const getParam = value => {
        if (value[0]) { setParams({ ...params, start: dayjs(value[0]).format('YYYY-MM-DD') }) }
        if (value[1]) { setParams({ ...params, end: dayjs(value[1]).format('YYYY-MM-DD') }) }
    }
    return (
        <div className={`h-[100vh] w-[100vw] left-[0] top-[0] ${!showReviewChart ? 'hidden' : ''}`}
            style={{ position: 'fixed', zIndex: 100, backgroundColor: 'rgba(0,0,0,.6)' }}>
            <div
                className=' left-[50%] top-[50%] bg-white absolute h-[auto] w-[60vw] rounded-[16px] border'
                style={{ transform: 'translate(-50%,-50%)', overflowY: 'auto', zIndex: 1000, }}
            >
                <div className='w-[100%] h-[95vh]'>
                    <div className='h-[10vh] w-[100%] flex items-center justify-left font-[20px] text-[#657585] font-[700] reltive pl-[40px]'>
                        {currentBranch.name} Reviews
                        <div
                            onClick={() => setShowReviewChart(false)}
                            className='absolute right-[2vw] bg-[#F5F6FA] btn w-[30px] h-[30px] flex items-center justify-center font-[400] font-[80%]'
                            style={{ borderRadius: '100%', cursor: 'pointer' }} > <GrFormClose size={20} color='#96A4B2' /> </div>
                    </div>
                    <div className='px-[40px]'>
                        <Box className='w-[100%] flex items-center justify-between h-[10%]'>
                            <div className='flex items-end w-[50%]'>
                                <Typography fontSize={{ xs: '30px', lg: '50px' }} color='black' className='my-0 py-0' fontWeight={700}>{Number(currentBranch.rating).toFixed(2)}</Typography>
                                <Box fontWeight={'700'} color='black' className='pb-2 pl-2'>Out of 5</Box>
                                <Box fontWeight={'700'} color='black' className='pb-2 pl-[60px]'>{currentBranch.total} Reviews</Box>
                            </div>
                            <div className='w-[50%] flex pl-[10%]' style={{ justifyContent: 'right' }}>
                                <ReachAfrikaDatePicker onChange={(val) => getParam(val)} />
                            </div>
                        </Box>
                        <Box className='w-[100%] p-5 h-[70vh]'>
                            <ReachBarChart left={'left-[7%]'} data={graphData?.data?.data} />
                        </Box>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default withTranslation()(ReviewChart) 